import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Качество",
  "lead": "Во всем мире большинство учителей проходят соответствующую подготовку, однако в странах Африки к югу от Сахары доля подготовленных учителей постепенно снизилась с 85 % в 2000 году до 64 % в 2022 году."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, HighlightByIndex, IndicatorReference, QualityFramework, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky, Tooltip} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!QualityFramework) _missingMdxReference("QualityFramework", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  if (!Tooltip) _missingMdxReference("Tooltip", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_QUALITY"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Качественное образование не может быть приравнено или сведено только к результатам обучения. Слишком много детей лишены достаточно подготовленных учителей, хорошей школьной инфраструктуры или безопасной ненасильственной среды обучения."
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Контроль качества образования является непростой задачей, поскольку каждая страна понимает и определяет его по-разному. Помимо результатов обучения, существует не так много показателей для измерения качества в глобальной цели в области образования — ЦУР 4."
    }), "\n", _jsx(_components.h2, {
      id: "учителя",
      children: "Учителя"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.c.2",
      children: [_jsx(_components.p, {
        children: "Учителя являются краеугольным камнем качества в образовании. Однако после 2000 года в ходе кампании по достижению всеобщего начального образования в классы пришло гораздо больше учеников, при этом темпы набора учителей были более медленными. В результате классы переполнены, а качество образования страдает."
      }), _jsx(QualityFramework, {
        highlighted: "учителя",
        description: "Подробнее о рамках качества образования"
      }), _jsx(_components.p, {
        children: "На графиках ниже показано соотношение учеников и учителей в школе. В некоторых странах Африки к югу от Сахары соотношение учеников на одного учителя все еще хуже, чем в 1980-х годах, хотя ситуация улучшилась с 2000 года."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "PTR"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["В ", _jsx(HighlightByIndex, {
              index: "0",
              children: "странах Африки к югу от Сахары"
            }), " в результате кампании по предоставлению бесплатного начального образования в период с 1990 по 2000 год детей зачисляли в классы быстрее, чем страны успевали набирать новых учителей. В результате этого соотношение числа учеников и учителей зачастую увеличивалось довольно существенно."]
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["Между тем в ", _jsx(HighlightByIndex, {
              index: "6",
              children: "Европе и Северной Америке"
            }), " это соотношение остается постоянным и составляет около 14 учеников на одного учителя с 2005 года."]
          })
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "Преподавание — сложная задача, и учителя, которые плохо подготовлены, приходят в класс с серьезным дефицитом знаний. Существует два основных способа, с помощью которых страны оценивают степень готовности учителей. Преподавателей оценивают по следующим критериям:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Во-первых, являются ли они  ", _jsx(_components.strong, {
          children: "квалифицированными"
        }), ", то есть имеют ли они необходимое образование в соответствии с национальными стандартами."]
      }), "\n", _jsxs(_components.li, {
        children: ["Во-вторых, являются ли они ", _jsx(_components.strong, {
          children: "подготовленными"
        }), ", то есть получили ли они соответствующую педагогическую подготовку, независимо от их квалификации."]
      }), "\n"]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.c.1",
      children: [_jsxs(_components.p, {
        children: ["Под подготовленностью подразумевается, что учителя овладели необходимыми ", _jsx(Tooltip, {
          title: "Педагогические знания",
          content: "Знание подходов, методов и приемов обучения.",
          children: "педагогическими знаниями "
        }), " и ", _jsx(Tooltip, {
          title: "Профессиональные знания",
          content: "Знание, например, правовых рамок, регулирующих профессию учителя.",
          children: "профессиональными знаниями"
        }), ". Некоторые программы могут также охватывать ", _jsx(Tooltip, {
          title: "Объем знаний",
          content: "Знание учебной программы, предмета и использование соответствующих материалов.",
          children: "объем знаний"
        }), ". Однако тип необходимой подготовки различается в зависимости от страны, а соответствующая информация доступна в недостаточном объеме. Из-за этих различий, несмотря на то, что показатель подготовленных учителей [4.c.1] является важнейшим элементом качественного образования, он является одним из наименее сопоставимых в системе мониторинга ЦУР 4."]
      }), _jsxs(_components.p, {
        children: ["Во всем мире большинство учителей имеют квалификацию и (или) прошли подготовку. Например, в ", _jsx(HighlightByIndex, {
          index: "3",
          children: "Латинской Америке и странах Карибского бассейна"
        }), " 80 % учителей имеют соответствующую подготовку."]
      }), _jsxs(_components.p, {
        children: ["Напротив, в ", _jsx(HighlightByIndex, {
          index: "0",
          children: "странах Африки к югу от Сахары"
        }), "процент подготовленных учителей снизился с 85 % в 2000 году до 64 % в 2022 году."]
      }), _jsx(Figure, {
        id: "TRAINED"
      }), _jsx(_components.p, {
        children: "Для стран, в которых не хватает квалифицированных и подготовленных учителей, нет простого решения. Во многих странах не хватает отвечающих требованиям учителей, чтобы удовлетворить спрос, учитывая общее низкое количество выпускников высших учебных заведений. Это демонстрирует, насколько взаимосвязанными могут стать проблемы в системе образования: проблемы на одном уровне, такие как низкий показатель завершения обучения в средней школе, могут легко привести к последствиям на другом уровне, таким как нехватка подготовленных учителей для учащихся в будущем."
      })]
    }), "\n", _jsx(_components.h2, {
      id: "инфраструктура",
      children: "Инфраструктура"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.a.1e",
      children: [_jsxs(_components.p, {
        children: ["Надлежащая образовательная среда должна иметь достаточное количество ", _jsx(_components.strong, {
          children: "воды"
        }), " и санитарных условий, особенно для девочек. Тем не менее вода была доступна только в 53 % начальных школ в странах Африки к югу от Сахары, в 77 % школ в Восточной и Юго-Восточной Азии и в 86 % школ в Центральной и Южной Азии."]
      }), _jsx(QualityFramework, {
        highlighted: "материал",
        description: "Подробнее о рамках качества образования"
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.a.1f",
      children: [_jsxs(_components.p, {
        children: ["В частности, ", _jsx(_components.strong, {
          children: "санитарно-гигиенические"
        }), " сооружения, в которых отсутствует возможность уединения, не могут считаться безопасными, а сооружения, в которых невозможно обеспечить соблюдение гигиены во время менструации, могут помешать девочкам посещать школу. Поэтому создание раздельных санитарных узлов является важнейшим шагом в политике по предотвращению широко распространенного позднего поступления в начальную школу и отсева девочек из школы с течением времени."]
      }), _jsx(_components.p, {
        children: "Как видно из приведенного ниже графика, менее половины начальных школ имеют раздельные санитарные узлы не только в странах Африки к югу от Сахары, но и в таких азиатских странах, как Афганистан, Лаосская Народно-Демократическая Республика и Непал. В Индонезии только 43 % начальных школ, 56 % младших классов и 65 % старших классов средних школ имеют раздельные санитарные узлы."
      }), _jsx(Figure, {
        id: "SANITATION"
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.a.1a",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Электричество"
        }), " является базовой потребностью для качественной среды обучения, однако во многих странах оно отсутствует. В странах с низким уровнем дохода 73 % начальных школ и 58 % старших классов средних школ не имеют электричества."]
      }), _jsx(_components.p, {
        children: "Как видно из приведенного ниже графика, в Никарагуа и Пакистане электричество есть менее чем в половине начальных школ. В некоторых странах Африки к югу от Сахары доступ к электричеству в школах крайне редок: в Мадагаскаре электричество есть в 12 % школ, а в Чаде — всего в 4 %. Без электричества освещение может быть недостаточным, и учителя не могут использовать компьютеры для административной работы или обучения. Отсутствие электричества означает отсутствие систем вентиляции, охлаждения и отопления, в связи с чем классные комнаты могут быть непригодными для преподавания и обучения."
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.a.1b",
      children: [_jsxs(_components.p, {
        children: ["Отсутствие электричества также означает невозможность использования современных технологий и ", _jsx(_components.strong, {
          children: "интернета"
        }), ". Однако электричество — не единственный фактор, замедляющий распространение интернета. В странах со средним уровнем дохода в 37 % начальных школ и 22 % старших классов средних школ есть электричество, но нет интернета. Даже если школы подключены к распределительной сети, часто случаются скачки напряжения и отключения электроэнергии. Подключение к интернету зависит от национальной телекоммуникационной инфраструктуры, географических особенностей территории и способности школ платить за эту услугу."]
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "ELECTRIC"
          })
        }), _jsx(ScrollySection, {
          id: "LKA",
          children: _jsxs(_components.p, {
            children: ["В ", _jsx(_components.strong, {
              children: "Шри-Ланке"
            }), ", хотя во всех начальных школах есть электричество, только 41 % из них имеют доступ к интернету. То же самое касается 34 % школ в Туркменистане и 32 % — в Иордании."]
          })
        }), _jsx(ScrollySection, {
          id: "ECU,URY",
          children: _jsxs(_components.p, {
            children: ["Во многих странах Латинской Америки есть школы, в которых нет ни электричества, ни интернета. Только около 43 % школ в ", _jsx(_components.strong, {
              children: "Эквадоре"
            }), " и 63 % в Аргентине имеют доступ к электричеству и интернету. Исключением является ", _jsx(_components.strong, {
              children: "Уругвай"
            }), ", где 100 % начальных школ имеют доступ к электричеству и интернету."]
          })
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "насилие",
      children: "Насилие"
    }), "\n", _jsx(_components.p, {
      children: "Насильственные действия или угрозы, связанные со школой, могут носить психологический, физический или сексуальный характер и могут происходить в школьных помещениях, а также по дороге в школу, дома или в киберпространстве. Зачастую они возникают из-за неравного распределения сил и часто являются результатом негативных гендерных норм и стереотипов."
    }), "\n", _jsx(_components.p, {
      children: "Хотя внимание обычно сосредоточено на чрезвычайных событиях, таких как стрельба, именно более распространенные и зачастую остающиеся незамеченными формы насилия, такие как притеснения, оказывают наибольшее негативное влияние на образование детей и подростков. Данные по этим вопросам остаются недостаточными, поскольку вопросы, которые задаются при сборе данных, включают разные определения агрессивного поведения, разные временные рамки для сообщения о случаях насилия, несопоставимые варианты ответов, меры по обеспечению конфиденциальности или этические протоколы. Это происходит в дополнение к частичному сокрытию информации о таких формах насилия, как притеснения на почве гомофобии, включая табу."
    }), "\n", _jsx(QualityFramework, {
      highlighted: "школа",
      description: "Подробнее о рамках качества образования"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.a.2",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Притеснения"
        }), " — наиболее широко документированная форма насилия в школах. Она может включать физическое насилие, словесные оскорбления и намерение причинить психологический вред посредством унижения или исключения. На рисунке ниже показано, что в большинстве стран жертвами притеснений становится как минимум каждый третий подросток, причем чаще мальчики, чем девочки."]
      }), _jsx(Figure, {
        id: "BULLY_FIGHT"
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Физическое насилие"
      }), " включает в себя участие в драках в школе, ношение или угрозу применения оружия, такого как пистолет, нож или дубинка, на территории школы, членство в или сообщничество с бандой или физическое насилие со стороны сотрудника школы."]
    }), "\n", _jsx(_components.p, {
      children: "По меньшей мере 10 % 15-летних мальчиков в 24 странах сообщили, что в 2022 году они участвовали в драках не менее 3 раз, в то время как в Армении этот показатель превысил 30 %."
    }), "\n", _jsx(_components.h2, {
      id: "заключение",
      children: "Заключение"
    }), "\n", _jsx(_components.p, {
      children: "Сопоставимые на международном уровне данные по показателям учителей на удивление скудны. Относительно небольшое количество стран предоставляют данные даже о базовой численности учителей, не говоря уже об учете учебных часов, совмещении административных должностей и других сложностях. Требуется разработать типологию стандартов подготовки учителей, чтобы мы могли правильно увидеть пробелы и вывести эту проблему на глобальный уровень."
    }), "\n", _jsx(_components.p, {
      children: "Как показано в этой статье, создание образовательных учреждений, «учитывающих интересы и потребности детей, инвалидов и гендерную проблематику», а также «безопасной, ненасильственной, инклюзивной и эффективной среды обучения для всех» является проблемой во многих странах. Между тем, измерить прогресс в этом отношении непросто, поскольку соответствующий глобальный показатель представляет собой не единичный критерий, а набор нескольких параметров."
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.oecd-ilibrary.org/education/education-at-a-glance_19991487",
            children: "Взгляд на образование — ОЭСР"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://theirworld.org/news/safe-schools-report-reveals-crises-challenges-action-needed-to-educate-children",
            children: "Отчет о безопасности школ — Their World"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://unesdoc.unesco.org/ark:/48223/pf0000232107",
            children: "Гендерное насилие в школах препятствует получению качественного образования для всех"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
